import { useCallback } from "react";
import { useActionsModal } from "./useActionsModal";
import { useCopyModal } from "./useCopyModal";
import { useDeleteModal } from "./useDeleteModal";
import { useImportModal } from "./useImportModal";
import { useTransferModal } from "./useTransferModal";

export const useModals = ({
    isTeamScheduler,
    params,
    mutate,
    setSelectedEvents,
    resetCount,
}) => {
    const {
        open: openActionModal,
        modal: actionModal
    } = useActionsModal({ mutate, params, isTeamScheduler, setSelectedEvents, resetCount });

    const {
        open: openTransferModal,
        modal: transferModal
    } = useTransferModal({ mutate, params, setSelectedEvents, resetCount });

    const {
        open: openCopyModal,
        modal: copyModal
    } = useCopyModal({ isTeamScheduler, params, mutate, setSelectedEvents, resetCount });

    const {
        open: openDeleteModal,
        modal: deleteModal
    } = useDeleteModal({ mutate, params, isTeamScheduler, setSelectedEvents, resetCount });

    const {
        open: openImportModal,
        modal: importModal
    } = useImportModal({
        onSuccess: useCallback(() => {
            resetCount();
            mutate();
        }, [resetCount, mutate]),
    });

    return {
        actionModal,
        openActionModal,
        transferModal,
        openTransferModal,
        copyModal,
        openCopyModal,
        deleteModal,
        openDeleteModal,
        importModal,
        openImportModal
    }
}